import { render, staticRenderFns } from "./ConsultSummaryPage.vue?vue&type=template&id=dbbf0c2c&"
import script from "./ConsultSummaryPage.vue?vue&type=script&lang=js&"
export * from "./ConsultSummaryPage.vue?vue&type=script&lang=js&"
import style0 from "./ConsultSummaryPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports